import { render, staticRenderFns } from "./ClinicCalendar.vue?vue&type=template&id=dad0cabc&scoped=true&"
import script from "./ClinicCalendar.vue?vue&type=script&lang=js&"
export * from "./ClinicCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ClinicCalendar.vue?vue&type=style&index=0&id=dad0cabc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad0cabc",
  null
  
)

export default component.exports